import { FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

export const StatsYearSelectorTrigger = ({ year }: { year: number }) => {
  const { colors } = useTheme()

  return (
    <FlexBox
      role="button"
      className={css`
        width: auto;
        height: 32px;
        gap: 6px;
        padding: 0 12px;
        background-color: ${colors.uiWhite20};
        border-radius: 100px;
        -webkit-tap-highlight-color: transparent;
      `}
      centerAll
    >
      <Text
        tag="span"
        type="subhead"
        className={css`
          font-size: 12px;
          line-height: 12px;
        `}
        color={colors.uiWhite}
      >
        {year}
      </Text>
      <Icon
        type="chevron"
        className={css`
          width: 7px;
        `}
        fill={colors.uiWhite}
      />
    </FlexBox>
  )
}
